import {Box} from "@mui/material";
import Grid from "@mui/material/Grid";
import type {Property} from "csstype";
import type React from "react";

type Props = {
    children: React.ReactNode;
    maxWidth?: Property.MaxWidth;
};

const MainDisplayContainer = ({children, maxWidth}: Props) => (
    <Box
        sx={{
            backgroundColor: "background.default",
        }}
    >
        <Grid
            container
            maxWidth={maxWidth ?? "lg"}
            sx={{
                margin: "auto",
                mt: 2,
                minHeight: "calc(100vh - 115px)",
                width: "100%",
            }}
        >
            {children}
        </Grid>
    </Box>
);

export default MainDisplayContainer;
